import React, { FC, useContext } from 'react'
import { PileNode } from '@src/generated/schema'
import { useTranslation } from 'react-i18next'
import { StyledPopover, StyledPopoverOption } from './PopoverTitle.styles'
import { closePopups } from '@src/helpers/DomManipulations'
import { MeContext, Permissions } from '@src/components/Providers'

export interface PopoverTitleProps {
  handleDeletePilesFromOrder: (pilesIds: string[]) => Promise<void>
  handleCreateInventoryLine?: (pile: PileNode) => Promise<void>
  piles: PileNode[]
}

export const PopoverTitle: FC<PopoverTitleProps> = ({
  handleDeletePilesFromOrder,
  piles,
  handleCreateInventoryLine,
}) => {
  const { t } = useTranslation()
  const { userHasPermission } = useContext(MeContext)
  const canChangeFinishedOrder = userHasPermission(Permissions.CAN_CHANGE_FINISHED_ORDER)
  const canAssignPiles = canChangeFinishedOrder && typeof handleCreateInventoryLine !== 'undefined'

  const handleSetValues = () => {
    handleDeletePilesFromOrder(piles.map((pile) => pile.id))
    closePopups()
  }

  const handleCreateInventory = () => {
    handleCreateInventoryLine?.(piles[0])
    closePopups()
  }

  return (
    <StyledPopover>
      {canAssignPiles && (
        <StyledPopoverOption onClick={handleCreateInventory}>
          {t('desktop.pages.orders.show.piles.popover.createInventory')}
        </StyledPopoverOption>
      )}
      <StyledPopoverOption onClick={handleSetValues}>
        {t('desktop.pages.orders.show.piles.popover.deleteMultiple')}
      </StyledPopoverOption>
    </StyledPopover>
  )
}
